import { Roles } from '@daghfal/core';

/** The roles a small nursery actually uses. The engine holds more; these are the ones offered (D-4). */
export const OFFERED_ROLES: readonly string[] = [Roles.tenant.owner, Roles.tenant.accountant, Roles.tenant.teacher];
